import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import Vuelidate from "vuelidate";
import Terms from "@/components/Terms.vue";
import VueNoty from "vuejs-noty";

import MainLayout from "./layouts/MainLayout.vue"
import SignupLayout from "./layouts/SignupLayout.vue"
import PolicyLayout from "./layouts/PolicyLayout.vue"
import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";
import vuetify from './plugins/vuetify'

Vue.config.productionTip = false;
Vue.use(Vuelidate);
Vue.use(VueNoty);
Vue.component("Terms", Terms);
Vue.component("undefined-layout", MainLayout)
Vue.component("main-layout", MainLayout)
Vue.component("signup-layout", SignupLayout)
Vue.component("policy-layout", PolicyLayout)
Vue.component("v-select", vSelect);

new Vue({
  router,
  store,
  created() {},
  vuetify,
  render: h => h(App)
}).$mount("#app");